module.exports = __webpack_public_path__ + "static/media/weikang1.44beaaab.png";